import React from "react";
import { Helmet } from "react-helmet";
import endpoints from "../../content/endpoints";
import { useState, useEffect, useRef, useCallback } from "react";
import Pagination from "../../components/Pagination/Pagination";

import "./style.sass";

const Imprensa = () => {
  const getInitialPage = () => {
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get("page") || "1", 10);
    return isNaN(page) || page < 1 ? 1 : page;
  };

  const sectionRef = useRef(null);
  const [data, setData] = useState({});
  const [currentPage, setCurrentPage] = useState(getInitialPage);
  const [totalPages, setTotalPages] = useState(null);

  const fetchData = useCallback(
    (url, currentPage) => {
      fetch(`${url}?page=${currentPage}`)
        .then((res) => res.json())
        .then((data) => {
          setData(data.data);

          if (totalPages === null) {
            setTotalPages(data.total);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    [setTotalPages, setData, totalPages]
  );

  const updateUrlParam = useCallback(
    (page) => {
      const url = new URL(window.location.href);
      url.searchParams.set("page", page);

      window.history.pushState({}, "", url);

      fetchData(endpoints.imprensa, page);
    },
    [fetchData]
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);

    const section = sectionRef.current;

    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    updateUrlParam(currentPage);
  }, [currentPage, updateUrlParam]);

  return (
    <main className="Imprensa">
      <div ref={sectionRef} className="Imprensa__ref"></div>
      <Helmet>
        <title>Imprensa | FRIBAL - Especialistas em Carne</title>
      </Helmet>
      <div className="Imprensa__header">
        <h2 className="Imprensa__title">Imprensa</h2>
        <p>Fique por dentro do que saiu na mídia sobre nós.</p>
      </div>
      <section className="Imprensa__content">
        <div className="Imprensa__container">
          {Array.isArray(data) &&
            data.map((item) => {
              return (
                <section key={item.id} className="Imprensa__projeto">
                  <a
                    className="Imprensa__link"
                    href={item.noticia_link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <h3 className="Imprensa__subtitle">
                      {item.noticia_titulo}
                    </h3>
                  </a>
                  <div className="Imprensa__description">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.texto || "",
                      }}
                    />
                  </div>
                  <div className="Imprensa__date">
                    <a
                      href={item.fonte_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.fonte_nome}
                    </a>
                    |
                    <p>
                      {new Date(item.noticia_data).toLocaleDateString("pt-BR")}
                    </p>
                  </div>
                </section>
              );
            })}
        </div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </section>
    </main>
  );
};

export default Imprensa;
